module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-alert-5bb6242b7154ffe66683e04682081c85.png";